import React from "react";
import { Outlet } from "react-router-dom";
import RavookaHeader from "./RavookaHeader";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";

const Layout = () => {
  return (
    <div
      className="app-layout"
      style={{ backgroundColor: "#050505", minHeight: "100vh" }}
    >
      <ScrollToTop />
      <RavookaHeader />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
